import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Column } from "@ant-design/plots";
import GetPlanLevelStatsApi from "../../api/performance/GetPlanLevelStatsApi";
import { SimpleLoader } from "../sub/Loaders";
import { Link } from "react-router-dom";

function PlanLevelStats() {
  const [planLevelsStats, setPlanLevelsStats] = useState([]);

  const perfCycleState = useSelector((state) => state.perfCycleState.value);

  const positionState = useSelector((state) => state.positionState.value);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getPlanLevelPerformanceStats();
  }, [perfCycleState]);

  async function getPlanLevelPerformanceStats() {
    setLoading(true);
    const apiResponse = await GetPlanLevelStatsApi(
      positionState?.id,
      perfCycleState?.id
    );

    if (apiResponse.success) {
      setPlanLevelsStats(apiResponse?.data);
      setLoading(false);
    }
  }

  const config = {
    data: planLevelsStats,
    xField: "level",
    yField: "objectCount",
    barWidthRatio: 0.8,
    position: "bottom",
    meta: {
      type: {
        alias: "类别",
      },
      sales: {
        alias: "销售额",
      },
    },
  };

  return (
    <div>
      {loading ? (
        <SimpleLoader />
      ) : (
        <Link
          to="/top-plans"
          className="border p-5 rounded-md block  text-black hover:text-black cursor-pointer"
        >
          <div className="mb-4">Plan Levels</div>
          <Column {...config} />
        </Link>
      )}
    </div>
  );
}

export default PlanLevelStats;
